import type { ReactNode } from 'react';

export const symbol_pin_drop: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480-276q109-83 164.5-169.5T700-600q0-97-61.5-158.5T480-820q-97 0-158.5 61.5T260-600q0 67 55.5 153.5T480-276Zm-18 59q-9-3-17-9-125-97-185-192.5T200-600q0-123 78.5-201.5T480-880q123 0 201.5 78.5T760-600q0 86-60 181.5T515-226q-8 6-17 9t-18 3q-9 0-18-3Zm17-303q34 0 57.5-23.5T560-600q0-33-23.5-56.5T479-680q-33 0-56 23.5T400-600q0 33 23 56.5t56 23.5ZM230-80q-13 0-21.5-8.5T200-110q0-13 8.5-21.5T230-140h500q13 0 21.5 8.5T760-110q0 13-8.5 21.5T730-80H230Zm250-520Z"
		/>
	</svg>
);
